import React, { Fragment } from 'react'
import { Grid, Row, Col } from 'rsuite'

export default function AdministrativeAreaView(props) {
  const { schema } = props

  const renderDetail = (province, index) => {
    return (
      <Fragment key={index}>
        <dl>
          <dt>&#9679; {province.name}</dt>
          <dd>- จำนวน {province.size} อำเภอ/เขต</dd>
          {province.isAll ? (
            <>
              <dd>- **ทุกอำเภอ/เขต</dd>
              <dd>- **ทุกตำบล/แขวง</dd>
            </>
          ) : (
            <dd>
              - ได้แก่
              {province.district.map((district, index) => {
                return (
                  <dl key={index} style={{ marginLeft: 20 }}>
                    <dt>
                      {index + 1}. {district.name}
                    </dt>
                    <dd>- จำนวน {district.size} ตำบล/แขวง</dd>
                    {district.isAll ? (
                      <dd>- **ทุกตำบล/แขวง</dd>
                    ) : (
                      <dd>
                        <dl style={{ marginLeft: 20 }}>
                          {district.subDistrict.map((district, index) => {
                            return <dd key={index}>- {district}</dd>
                          })}
                        </dl>
                      </dd>
                    )}
                  </dl>
                )
              })}
            </dd>
          )}
        </dl>
      </Fragment>
    )
  }

  return (
    <div>
      {schema.areaList.data?.length > 0 ? (
        <Row>
          <Col xs={24} sm={12} md={8} lg={8}>
            {schema.areaList.data.map((province, index) => {
              return index % 3 == 0 && renderDetail(province, index)
            })}
          </Col>

          <Col xs={24} sm={12} md={8} lg={8}>
            {schema.areaList.data.map((province, index) => {
              return index % 3 == 1 && renderDetail(province, index)
            })}
          </Col>

          <Col xs={24} sm={12} md={8} lg={8}>
            {schema.areaList.data.map((province, index) => {
              return index % 3 == 2 && renderDetail(province, index)
            })}
          </Col>
        </Row>
      ) : (
        `- ไม่พบข้อมุล ${schema.header} -`
      )}
    </div>
  )
}
